"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var usePrice = function (prices) {
    var priceDisplay = usePlatformConfig_1.default().platformConfig.priceDisplay;
    var defaultPrice = {
        money: {
            amount: 0,
            currency: '',
        },
        type: '',
    };
    var _a = react_1.useMemo(function () {
        var _a;
        var _b = (_a = prices) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, price) {
            var _a, _b;
            var isPrimaryPrice = price.money.currency === priceDisplay.primary.currency;
            var isSecondaryPrice = ((_b = (_a = priceDisplay) === null || _a === void 0 ? void 0 : _a.secondary) === null || _b === void 0 ? void 0 : _b.currency) && price.money.currency === priceDisplay.secondary.currency;
            return __assign(__assign(__assign({}, acc), (isPrimaryPrice && { primaryPrice: price })), (isSecondaryPrice && { secondaryPrice: price }));
        }, {}), primaryPrice = _b.primaryPrice, secondaryPrice = _b.secondaryPrice;
        return { primaryPrice: primaryPrice, secondaryPrice: secondaryPrice };
    }, [prices, priceDisplay]), _b = _a.primaryPrice, primaryPrice = _b === void 0 ? defaultPrice : _b, _c = _a.secondaryPrice, secondaryPrice = _c === void 0 ? defaultPrice : _c;
    return { primaryPrice: primaryPrice, secondaryPrice: secondaryPrice };
};
exports.default = usePrice;
